import styled from 'styled-components';

import { Button as ButtonLayoutComponent, CenteredLoader } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 25px 40px 40px 40px;
`;

export const Loader = styled(CenteredLoader)``;

export const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 110px;

    :last-child {
      margin-left: 20px;
    }
  }
`;
